export default {
    state: {
        assets: [],
        search_results: []
    },
    mutations: {
        setMerlinAssets (state, payload) {
            state.assets = payload
        },
        setMerlinSearchResults (state, payload) {
            state.search_results = payload
        }
    },
    actions: {
        getMerlinAssets (context, merlin_ids) {
            return new Promise((resolve, reject) => {
                this._vm.axios.post('/api/merlin/get', {
                    merlin_ids: merlin_ids
                })
                .then(response => {
                    let assets = []

                    if (response.data) {
                        assets = response.data
                    }

                    context.commit('setMerlinAssets', assets)

                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        },
        searchMerlin (context, search_term) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get('/api/merlin/search/' + search_term)
                .then(response => {
                    let search_results = []

                    if (response.data) {
                        search_results = response.data
                    }

                    context.commit('setMerlinSearchResults', search_results)

                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        },
        searchMerlinImages (context, search_term) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get('/api/merlin/search_images/' + search_term)
                .then(response => {
                    let search_results = []

                    if (response.data) {
                        search_results = response.data
                    }

                    context.commit('setMerlinSearchResults', search_results)

                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        },
        searchMerlinAudio (context, search_term) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get('/api/merlin/search_audio/' + search_term)
                .then(response => {
                    let search_results = []

                    if (response.data) {
                        search_results = response.data
                    }

                    context.commit('setMerlinSearchResults', search_results)

                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        }
    }
}
